
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.334 5.735a8.49 8.49 0 01-2.435.668 4.25 4.25 0 001.864-2.347 8.464 8.464 0 01-2.692 1.029 4.241 4.241 0 00-7.225 3.868 12.04 12.04 0 01-8.74-4.43 4.241 4.241 0 001.312 5.661 4.23 4.23 0 01-1.92-.531v.054A4.241 4.241 0 005.9 13.865a4.271 4.271 0 01-1.915.073 4.241 4.241 0 003.961 2.943 8.508 8.508 0 01-5.266 1.816c-.338 0-.676-.02-1.012-.06a11.991 11.991 0 006.498 1.906c7.8 0 12.064-6.46 12.064-12.063 0-.182-.004-.366-.012-.548a8.619 8.619 0 002.114-2.194l.002-.003z","fill":"#ABAFB5"}})])
          )
        }
      }
    